import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["dropdown", "textArea", "titleInput", "templateId"];
  static values = { templates: Array };

  connect() {
    // Add click outside listener
    document.addEventListener("click", this.clickOutside.bind(this));
  }

  disconnect() {
    // Remove click outside listener
    document.removeEventListener("click", this.clickOutside.bind(this));
  }

  selectTemplate(event) {
    const templateId = event.currentTarget.dataset.templateId;
    const template = this.templatesValue.find((t) => t.id === templateId);

    console.log("🍐 Clicked template", {
      template,
      templateId,
      templatesValue: this.templatesValue,
      hasTextAreaTarget: this.hasTextAreaTarget,
      hasTitleInputTarget: this.hasTitleInputTarget,
      hasTemplateIdTarget: this.hasTemplateIdTarget,
    });

    if (template) {
      // Update the text area with template content
      if (this.hasTextAreaTarget) {
        this.textAreaTarget.value = template.text;
      }

      // Update the title input if it exists
      if (this.hasTitleInputTarget) {
        this.titleInputTarget.value = template.title;
      }

      // Update the hidden template ID field
      if (this.hasTemplateIdTarget) {
        this.templateIdTarget.value = templateId;
      }

      // Close the dropdown
      this.closeDropdown();
    }
  }

  toggleDropdown() {
    this.dropdownTarget.classList.toggle("hidden");
  }

  closeDropdown() {
    this.dropdownTarget.classList.add("hidden");
  }

  // Close dropdown when clicking outside
  clickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.closeDropdown();
    }
  }
}
